module.exports = __webpack_public_path__ + "static/content-1-a0a4b07a688233c08b5d99850e18d483.png";